import React from 'react';

export default function DnaDomainVis(): JSX.Element {
  return (
    <>
      <path
        d="M12.7735 17.7775L13.0759 17.5526C13.519 17.223 13.6143 16.5942 13.2886 16.1482L7.45041 8.151C7.12476 7.70493 6.50153 7.61051 6.05837 7.94011L5.75605 8.16496M9.45937 20.2423L9.15705 20.4672C8.71389 20.7968 8.09066 20.7024 7.76501 20.2563L1.92678 12.2591C1.60113 11.8131 1.69639 11.1843 2.13955 10.8547L2.44187 10.6298"
        stroke="#8DB800"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 9.49818 14.9839)"
        stroke="#8DB800"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 6.55002 10.9453)"
        stroke="#8DB800"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 5.49805 17.8638)"
        stroke="#8DB800"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 2.54988 13.8252)"
        stroke="#8DB800"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <path
        d="M21.5656 29.7775L21.868 29.5526C22.3111 29.223 22.4064 28.5942 22.0807 28.1482L16.2425 20.151C15.9169 19.7049 15.2936 19.6105 14.8505 19.9401L14.5481 20.165M18.2515 32.2423L17.9491 32.4672C17.506 32.7968 16.8828 32.7024 16.5571 32.2563L10.7189 24.2591C10.3932 23.8131 10.4885 23.1843 10.9316 22.8547L11.234 22.6298"
        stroke="#ACDA11"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 18.2903 26.9839)"
        stroke="#ACDA11"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 15.3421 22.9453)"
        stroke="#ACDA11"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 14.2901 29.8638)"
        stroke="#ACDA11"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 11.342 25.8252)"
        stroke="#ACDA11"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <path
        d="M59.2265 17.777L58.9241 17.5521C58.481 17.2225 58.3857 16.5937 58.7114 16.1477L64.5496 8.15051C64.8752 7.70445 65.4985 7.61003 65.9416 7.93962L66.244 8.16447M62.5406 20.2418L62.843 20.4667C63.2861 20.7963 63.9093 20.7019 64.235 20.2558L70.0732 12.2587C70.3989 11.8126 70.3036 11.1838 69.8605 10.8542L69.5581 10.6294"
        stroke="#8DB800"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 62.5018 14.9834)"
        stroke="#8DB800"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 65.45 10.9448)"
        stroke="#8DB800"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 66.502 17.8633)"
        stroke="#8DB800"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 69.4501 13.8247)"
        stroke="#8DB800"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <path
        d="M50.4344 29.7775L50.132 29.5526C49.6889 29.223 49.5936 28.5942 49.9193 28.1482L55.7575 20.151C56.0831 19.7049 56.7064 19.6105 57.1495 19.9401L57.4519 20.165M53.7485 32.2423L54.0509 32.4672C54.494 32.7968 55.1172 32.7024 55.4429 32.2563L61.2811 24.2591C61.6068 23.8131 61.5115 23.1843 61.0684 22.8547L60.766 22.6298"
        stroke="#ACDA11"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 53.7097 26.9839)"
        stroke="#ACDA11"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 56.6579 22.9453)"
        stroke="#ACDA11"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 57.7099 29.8638)"
        stroke="#ACDA11"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 60.658 25.8252)"
        stroke="#ACDA11"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <path
        d="M20.5888 11.777L20.8911 11.5521C21.3342 11.2225 21.4295 10.5937 21.1038 10.1477L15.2656 2.15051C14.94 1.70445 14.3167 1.61003 13.8736 1.93962L13.5713 2.16447M17.2746 14.2418L16.9723 14.4667C16.5291 14.7963 15.9059 14.7019 15.5802 14.2558L9.74198 6.25865C9.41633 5.81259 9.51159 5.18379 9.95475 4.8542L10.2571 4.62935"
        stroke="#2C55E7"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 17.3134 8.9834)"
        stroke="#2C55E7"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 14.3652 4.94482)"
        stroke="#2C55E7"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 13.3132 11.8633)"
        stroke="#2C55E7"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 10.3651 7.82471)"
        stroke="#2C55E7"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <path
        d="M29.3808 23.7775L29.6832 23.5526C30.1263 23.223 30.2216 22.5942 29.8959 22.1482L24.0577 14.151C23.7321 13.7049 23.1088 13.6105 22.6657 13.9401L22.3633 14.165M26.0667 26.2423L25.7643 26.4672C25.3212 26.7968 24.698 26.7024 24.3723 26.2563L18.5341 18.2591C18.2084 17.8131 18.3037 17.1843 18.7468 16.8547L19.0492 16.6298"
        stroke="#7190FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 26.1055 20.9839)"
        stroke="#7190FF"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 23.1573 16.9453)"
        stroke="#7190FF"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 22.1053 23.8638)"
        stroke="#7190FF"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(0.802405 -0.59678 -0.589632 -0.807672 19.1572 19.8252)"
        stroke="#7190FF"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <path
        d="M33.4131 46.9995L33.7786 46.9995C34.3309 46.9995 34.7727 46.5518 34.7654 45.9996L34.6339 36.0003C34.6266 35.4481 34.173 35.0004 33.6207 35.0004L33.2552 35.0004M29.3165 46.9995L28.951 46.9995C28.3987 46.9995 27.9451 46.5518 27.9378 45.9996L27.8063 36.0003C27.799 35.4481 28.2409 35.0004 28.7932 35.0004L29.1587 35.0004"
        stroke="#7190FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.05111"
        y2="-0.875"
        transform="matrix(1 -2.2243e-09 -0.0131528 -0.999913 32.3676 42.7681)"
        stroke="#7190FF"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.05111"
        y2="-0.875"
        transform="matrix(1 -8.94507e-10 -0.0131528 -0.999913 32.3018 37.7686)"
        stroke="#7190FF"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.05111"
        y2="-0.875"
        transform="matrix(1 -2.16947e-09 -0.0131528 -0.999913 27.4777 42.6914)"
        stroke="#7190FF"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.05111"
        y2="-0.875"
        transform="matrix(1 -8.39682e-10 -0.0131528 -0.999913 27.4119 37.6919)"
        stroke="#7190FF"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <path
        d="M33.4131 61L33.7786 61C34.3309 61 34.7727 60.5523 34.7654 60.0001L34.6339 50.0008C34.6266 49.4486 34.173 49.0009 33.6207 49.0009L33.2552 49.0009M29.3165 61L28.951 61C28.3987 61 27.9451 60.5523 27.9378 60.0001L27.8063 50.0008C27.799 49.4486 28.2409 49.0009 28.7932 49.0009L29.1587 49.0009"
        stroke="#7190FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.05111"
        y2="-0.875"
        transform="matrix(1 -2.2243e-09 -0.0131528 -0.999913 32.3676 56.7686)"
        stroke="#7190FF"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.05111"
        y2="-0.875"
        transform="matrix(1 -8.94507e-10 -0.0131528 -0.999913 32.3018 51.769)"
        stroke="#7190FF"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.05111"
        y2="-0.875"
        transform="matrix(1 -2.16947e-09 -0.0131528 -0.999913 27.4777 56.6919)"
        stroke="#7190FF"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.05111"
        y2="-0.875"
        transform="matrix(1 -8.39682e-10 -0.0131528 -0.999913 27.4119 51.6924)"
        stroke="#7190FF"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <path
        d="M28.3533 26.0005L30.8119 28.5361C31.1814 28.9172 31.3843 29.4295 31.3759 29.9602L31.2957 35.0007"
        stroke="#979799"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M51.9057 11.777L51.6033 11.5521C51.1602 11.2225 51.0649 10.5937 51.3906 10.1477L57.2288 2.15051C57.5545 1.70445 58.1777 1.61003 58.6208 1.93962L58.9232 2.16447M55.2198 14.2418L55.5222 14.4667C55.9653 14.7963 56.5886 14.7019 56.9142 14.2558L62.7524 6.25865C63.0781 5.81259 62.9828 5.18379 62.5397 4.8542L62.2373 4.62935"
        stroke="#2C55E7"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 55.181 8.9834)"
        stroke="#2C55E7"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 58.1292 4.94482)"
        stroke="#2C55E7"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 59.1812 11.8633)"
        stroke="#2C55E7"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 62.1293 7.82471)"
        stroke="#2C55E7"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <path
        d="M43.1136 23.7775L42.8113 23.5526C42.3681 23.223 42.2728 22.5942 42.5985 22.1482L48.4367 14.151C48.7624 13.7049 49.3856 13.6105 49.8288 13.9401L50.1311 14.165M46.4278 26.2423L46.7301 26.4672C47.1732 26.7968 47.7965 26.7024 48.1221 26.2563L53.9604 18.2591C54.286 17.8131 54.1907 17.1843 53.7476 16.8547L53.4453 16.6298"
        stroke="#7190FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 46.3889 20.9839)"
        stroke="#7190FF"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 49.3371 16.9453)"
        stroke="#7190FF"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 50.3891 23.8638)"
        stroke="#7190FF"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.07522"
        y2="-0.875"
        transform="matrix(-0.802405 -0.59678 0.589632 -0.807672 53.3372 19.8252)"
        stroke="#7190FF"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <path
        d="M39.0814 46.9995L38.7158 46.9995C38.1636 46.9995 37.7217 46.5518 37.729 45.9996L37.8605 36.0003C37.8678 35.4481 38.3214 35.0004 38.8737 35.0004L39.2392 35.0004M43.1779 46.9995L43.5434 46.9995C44.0957 46.9995 44.5493 46.5518 44.5566 45.9996L44.6881 36.0003C44.6954 35.4481 44.2535 35.0004 43.7013 35.0004L43.3357 35.0004"
        stroke="#7190FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.05111"
        y2="-0.875"
        transform="matrix(-1 -2.2243e-09 0.0131528 -0.999913 40.1269 42.7681)"
        stroke="#7190FF"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.05111"
        y2="-0.875"
        transform="matrix(-1 -8.94507e-10 0.0131528 -0.999913 40.1926 37.7686)"
        stroke="#7190FF"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.05111"
        y2="-0.875"
        transform="matrix(-1 -2.16947e-09 0.0131528 -0.999913 45.0168 42.6914)"
        stroke="#7190FF"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.05111"
        y2="-0.875"
        transform="matrix(-1 -8.39682e-10 0.0131528 -0.999913 45.0825 37.6919)"
        stroke="#7190FF"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <path
        d="M39.0814 61L38.7158 61C38.1636 61 37.7217 60.5523 37.729 60.0001L37.8605 50.0008C37.8678 49.4486 38.3214 49.0009 38.8737 49.0009L39.2392 49.0009M43.1779 61L43.5434 61C44.0957 61 44.5493 60.5523 44.5566 60.0001L44.6881 50.0008C44.6954 49.4486 44.2535 49.0009 43.7013 49.0009L43.3357 49.0009"
        stroke="#7190FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.05111"
        y2="-0.875"
        transform="matrix(-1 -2.2243e-09 0.0131528 -0.999913 40.1269 56.7686)"
        stroke="#7190FF"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.05111"
        y2="-0.875"
        transform="matrix(-1 -8.94507e-10 0.0131528 -0.999913 40.1926 51.769)"
        stroke="#7190FF"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.05111"
        y2="-0.875"
        transform="matrix(-1 -2.16947e-09 0.0131528 -0.999913 45.0168 56.6919)"
        stroke="#7190FF"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <line
        x1="0.875"
        y1="-0.875"
        x2="2.05111"
        y2="-0.875"
        transform="matrix(-1 -8.39682e-10 0.0131528 -0.999913 45.0825 51.6924)"
        stroke="#7190FF"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <path
        d="M44.1411 26.0005L41.6825 28.5361C41.313 28.9172 41.1101 29.4295 41.1186 29.9602L41.1987 35.0007"
        stroke="#979799"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
    </>
  );
}
